var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"a-close-button close-button",attrs:{"type":"button","aria-label":_vm.ariaLabel},on:{"click":_vm.onClick}},[_c('svg-icon',{staticClass:"close-button__icon",attrs:{"original":"","name":"icons/close-circle"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }